import React from 'react';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import '../Header/header.module.css';
import "./index.css";
import Navigation from '../Navigation';
import { LOGO_MARK_PATH } from '../../constants/branding';

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: 'var(--ms-header-bg)',
        color: '#f5f7f8',
        boxShadow: 'none',
      },
    },
    MuiButton: {
      contained: {
        backgroundColor: '#edc917',
        color: '#47494b',
        fontFamily: 'Oswald',
        fontSize: '21px',
        fontWeight: '300',
        minHeight: '50px',
        minWidth: '186px',
        borderRadius: '0px',
        boxShadow: 'none'
      }
    },
    MuiFab: {
      secondary: {
        '&:hover:not($disabled)': {
          backgroundColor: 'transparent',
          color: '#f5f7f8',
          border: '1px solid #f5f7f8'
        },
        backgroundColor: 'transparent',
        color: '#4e6155',
        border: '1px solid #4e6155'
      }
    }
  }
});

class Layout extends React.Component {

  render() {
    const { children, showFooter } = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        <Navigation LocalTitle={this.props.title} showFooter={showFooter}>
          <React.Fragment>
            <head>
              <link rel="icon" href="/favicon.ico" sizes="any" />
              <link rel="icon" type="image/png" href={LOGO_MARK_PATH} />
              <link rel="apple-touch-icon" href={LOGO_MARK_PATH} />
              <meta name="description" content="Mimosa Membership Management" />
              <meta name="keywords" content="mimosa, membership management, m3 system" />
              <meta name="format-detection" content="telephone=no"></meta>
            </head>
            {children}
          </React.Fragment>
        </Navigation>
      </MuiThemeProvider>
    )
  }
}

export default Layout;